import _ from 'lodash';
import { ACL } from '.';
import { AdminACL } from './admin';
export const ACL_ROLE_SUPER_ADMINISTRATOR = 'Super Administrator';

export const SuperAdminACL: ACL = _.merge({}, AdminACL, {
  role: ACL_ROLE_SUPER_ADMINISTRATOR,
  is_superadmin: true,
});
